export default "__VITE_ASSET__ysKI2GW5__"